import { NgModule } from '@angular/core';
import { NcSplashScreenComponent } from './nc-splash-screen.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@NgModule({
  declarations: [NcSplashScreenComponent],
  imports: [
    MatProgressBarModule
  ],
  exports: [NcSplashScreenComponent]
})
export class NcSplashScreenModule { }
